import { useTypedSelector } from './useTypedSelector'

export const useIsCaseworker = () => {
    const { isLoggedIn, user } = useTypedSelector((state) => state.auth)

    if (
        isLoggedIn &&
        user?.roles.some(
            (role: string) => role === 'contact' || role === 'caseworker'
        )
    ) {
        return true
    } else {
        return false
    }
}
